import React, { Component, useContext } from 'react';

import * as SkooldioCapacitor from './SkooldioCapacitor';
import { CapacitorContext } from './context';

class CapacitorProvider extends Component {
  constructor() {
    super();
    this.provider = undefined;
    this.appState = undefined;
    this.userInfo = {};
    this.state = {};
  }

  getUserInfo = () => {
    return this.userInfo || {};
  };

  setUserInfo = (userInfo) => {
    this.userInfo = userInfo;
  };

  getAppState = () => {
    return this.appState;
  };

  setAppState = (appState) => {
    this.appState = appState;
  };

  getUserProvider = () => {
    return this.provider;
  };

  setUserProvider = (provider) => {
    this.provider = provider;
  };

  checkInvalidDevice = async (loggingFunctions) => {
    const {
      logRootedDeviceAction,
      logEmulatorAction,
      logScreenRecordAction,
      logMultiScreenAction,
    } = loggingFunctions;
    await this.checkRootedDevice(logRootedDeviceAction);
    await this.checkEmulator(logEmulatorAction);
    await this.checkScreenRecording(logScreenRecordAction);
    await this.checkMultiScreen(logMultiScreenAction);
  };

  validateDeviceAndShowWarningMessage = async (validateFunction, loggingFunction, messageInfo) => {
    const isNotValid = await validateFunction();
    if (isNotValid) {
      await loggingFunction();
      await SkooldioCapacitor.alertWarningDialog(this.getUserInfo, messageInfo);
    }
  };

  checkRootedDevice = async (logRootedDeviceAction) => {
    const messageInfo = {
      title: 'พบการใช้งานบนเครื่อง rooted หรือ jailbreak',
      message:
        'ไม่อนุญาตให้ใช้งานบนเครื่อง rooted หรือ jailbreak\nการใช้งานบนเครื่อง rooted หรือ jailbreak อาจก่อให้เกิดการละเมิดลิขสิทธิ์',
    };
    await this.validateDeviceAndShowWarningMessage(
      SkooldioCapacitor.isRootedDevice,
      logRootedDeviceAction,
      messageInfo
    );
  };

  checkEmulator = async (logEmulatorAction) => {
    const messageInfo = {
      title: 'พบการใช้งานบนเครื่อง Emulator',
      message: 'ไม่อนุญาตให้ใช้งานบนเครื่อง Emulator',
    };
    await this.validateDeviceAndShowWarningMessage(
      SkooldioCapacitor.isEmulator,
      logEmulatorAction,
      messageInfo
    );
  };

  checkScreenRecording = async (logScreenRecordAction) => {
    const messageInfo = {
      title: 'พบการบันทึกวีดีโอหน้าจอ',
      message:
        'การบันทึกวีดีโอหน้าจอถือเป็นการละเมิดลิขสิทธิ์\nแต่น้องยังสามารถบันทึกภาพ screenshot หน้าจอเพื่อนำไปจดต่อได้',
    };
    await this.validateDeviceAndShowWarningMessage(
      SkooldioCapacitor.isRecording,
      logScreenRecordAction,
      messageInfo
    );
  };

  checkMultiScreen = async (logMultiScreenAction) => {
    const messageInfo = {
      title: 'พบการใช้งานหลายหน้าจอ',
      message: 'ไม่อนุญาตให้ใช้งานหลายหน้าจอ',
    };
    await this.validateDeviceAndShowWarningMessage(
      SkooldioCapacitor.isMultiScreen,
      logMultiScreenAction,
      messageInfo
    );
  };

  alertTimeOut = async () => {
    SkooldioCapacitor.alertTimeOut();
  };

  async componentDidMount() {
    this.haveCapacitor = true;
    this.setState({ deviceInfo: await SkooldioCapacitor.getDeviceInfo() });
    if (process.env.PLATFORM === 'ios') {
      SkooldioCapacitor.checkiOSSupportVersion();
    }
  }

  render() {
    return (
      <CapacitorContext.Provider
        value={{
          capacitor: SkooldioCapacitor,
          checkInvalidDevice: this.checkInvalidDevice,
          setUserInfo: this.setUserInfo,
          getUserInfo: this.getUserInfo,
          setUserProvider: this.setUserProvider,
          getUserProvider: this.getUserProvider,
          openUrl: SkooldioCapacitor.openUrl,
          scanBarcode: SkooldioCapacitor.scanBarcode,
          alertTimeOut: this.alertTimeOut,
          getAppState: this.getAppState,
          isNative: SkooldioCapacitor.isNative,
          origin: SkooldioCapacitor.origin,
          routeListener: SkooldioCapacitor.routeListener,
          requestAppReview: SkooldioCapacitor.requestAppReview,
          deviceInfo: this.state.deviceInfo,
          openInApp: SkooldioCapacitor.openInApp,
        }}
      >
        {this.props.children}
      </CapacitorContext.Provider>
    );
  }
}

const useCapacitor = () => {
  const context = useContext(CapacitorContext);
  if (context === undefined) {
    throw new Error('useCapacitor must be used within CapacitorContextProvider');
  }
  return context;
};

export { useCapacitor };
export default CapacitorProvider;
